import(/* webpackMode: "eager", webpackExports: ["DiscoverPage"] */ "/workspace/src/components/discover-page.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/workspace/src/components/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/workspace/src/components/header.tsx");
